// extracted by mini-css-extract-plugin
export var dropdownButton = "_19-0";
export var fullWidthDropdownButton = "_19-1";
export var icon = "_19-3";
export var iconPlaceholder = "_19-2";
export var menuItemRow = "_19-9";
export var separator = "_19-e";
export var shortcutContainer = "_19-7";
export var shortcutContainerFilled = "_19-8";
export var shortcutIconLg = "_19-6";
export var shortcutIconMd = "_19-5";
export var shortcutIconSm = "_19-4";
export var submenuChevron = "_19-d";
export var submenuDropdown = "_19-a";
export var submenuTriggerRow = "_19-b";
export var submenuTriggerRowOpen = "_19-c";